import React from 'react';
import { Modal } from 'semantic-ui-react';
import {
  Container,
  Header,
  Body,
  TableContainer,
  TableTitle,
  TableHeader,
  TableRow,
  TableItemName,
  TableItemAssistance,
  ContainerImage,
  Logo
} from './styles';
import { residentials, businesses } from './assistances.constants';
import logoLadoBom from '../../../../../../../resources/imgs/logo-lado-bom-seguros.svg';
import logoTokio from '../../../../../../../resources/imgs/logo-tokio.svg';
import { HiCheck, HiOutlineX } from 'react-icons/hi';

interface AssistanceTableModalProp {
  isOpen: boolean;
  onClose: () => void;
}

const AssistanceTableModal = ({ isOpen, onClose }: AssistanceTableModalProp) => {
  const check = (isCheck: boolean) =>
    isCheck ? (
      <HiCheck size="20px" color="#5FBC7F" />
    ) : (
      <HiOutlineX size="20px" color="#E93232" />
    );

  return (
    <Modal open={isOpen} onClose={onClose} size={'large'} closeIcon>
      <Container>
        <Header>
          <h3>Tabela de assistências</h3>
          <Logo src={logoTokio} width="225px" />
        </Header>
        <Modal.Content scrolling>
          <Body>
            <TableContainer>
              <TableTitle isTop>Residencial</TableTitle>
              <TableHeader>
                <TableItemName>Itens</TableItemName>
                <TableItemAssistance>Assistência Essencial</TableItemAssistance>
                <TableItemAssistance>Assistência Mais</TableItemAssistance>
                <TableItemAssistance>Assistência Super</TableItemAssistance>
              </TableHeader>
              {residentials.map((res, i) => {
                return (
                  <TableRow key={i} offwhite={i % 2 == 1}>
                    <TableItemName>{res.item}</TableItemName>
                    <TableItemAssistance>{check(res.essential)}</TableItemAssistance>
                    <TableItemAssistance>{check(res.plus)}</TableItemAssistance>
                    <TableItemAssistance>{check(res.super)}</TableItemAssistance>
                  </TableRow>
                );
              })}
              <TableTitle>Empresarial</TableTitle>
              <TableHeader>
                <TableItemName width="60%">Itens</TableItemName>
                <TableItemAssistance>Sem assistência 24h</TableItemAssistance>
                <TableItemAssistance>Com assistência 24h</TableItemAssistance>
              </TableHeader>
              {businesses.map((bus, i) => {
                return (
                  <TableRow
                    key={i}
                    offwhite={i % 2 == 1}
                    lastLine={businesses.length === i + 1}
                  >
                    <TableItemName width="60%">{bus.item}</TableItemName>
                    <TableItemAssistance>
                      {check(bus.withoutAssistence24)}
                    </TableItemAssistance>
                    <TableItemAssistance>
                      {check(bus.withAssistence24)}
                    </TableItemAssistance>
                  </TableRow>
                );
              })}
              <ContainerImage>
                <Logo src={logoLadoBom} />
              </ContainerImage>
            </TableContainer>
          </Body>
        </Modal.Content>
      </Container>
    </Modal>
  );
};

export default AssistanceTableModal;
